"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProgramTag = void 0;
const react_1 = __importStar(require("react"));
const fds_1 = require("@tcc/fds");
const classnames_1 = __importDefault(require("classnames"));
const utils_1 = require("../../utils");
const programs_1 = require("../../constants/programs");
const styles = __importStar(require("./styles.css"));
const ProgramTag = ({ program, testId, url }) => {
    const sanitizedProgram = (0, utils_1.toKebabCase)(program || '');
    const logo = (0, react_1.useMemo)(() => {
        if (url)
            return url;
        if (sanitizedProgram && programs_1.programsLogos[sanitizedProgram])
            return programs_1.programsLogos[sanitizedProgram];
        return undefined;
    }, [sanitizedProgram, url]);
    if (!logo) {
        return null;
    }
    const programTagImgClass = (0, classnames_1.default)(styles.programTagImg);
    const programTestId = (0, classnames_1.default)(`${sanitizedProgram}-program-tag`, testId);
    return (react_1.default.createElement(fds_1.Tag, { testId: programTestId, fill: "solid", sides: "pill", backgroundColor: "#ffffff" },
        react_1.default.createElement("img", { alt: `${sanitizedProgram} logo`, src: logo, "data-test-id": `${sanitizedProgram}-program-logo`, className: programTagImgClass })));
};
exports.ProgramTag = ProgramTag;
